import React from 'react'
import { Menu, Sun, Moon } from 'lucide-react'
import './Header.css'

interface HeaderProps {
  onMenuClick: () => void
}

const Header: React.FC<HeaderProps> = ({ onMenuClick }) => {
  const [isDark, setIsDark] = React.useState(false)

  const toggleTheme = () => {
    setIsDark(!isDark)
    document.documentElement.classList.toggle('dark')
  }

  return (
    <header className="header">
      <div className="header-content">
        <img src="/horlogo.png" alt="ingenious horizontal logo" className="header-horlogo" />
        <button className="menu-button" onClick={onMenuClick}>
          <Menu size={24} />
        </button>
        
        <div className="header-actions">
          <button className="theme-toggle" onClick={toggleTheme}>
            {isDark ? <Sun size={20} /> : <Moon size={20} />}
          </button>
        </div>
      </div>
    </header>
  )
}

export default Header 